// URLs gravadas pela loja (storeUrl, links de produto) vão para href. O React 17 só avisa
// sobre `javascript:` e renderiza mesmo assim, então link fora de http(s) não é exibido.
export const safeHttpUrl = (url?: string | null): string | undefined => {
  if (typeof url !== 'string') return undefined
  const trimmed = url.trim()
  return /^https?:\/\//i.test(trimmed) ? trimmed : undefined
}
